import {TextualDataBuilder} from './TextualDataBuilder'
import {DATA} from '@wix/component-protocol/schema' // eslint-disable-line wix-editor/no-internal-import
import type {Builder} from '@wix/document-services-types'

export class TextBuilder extends TextualDataBuilder {
    constructor(displayName: string, defaultValue: string, private maxLength?: number) {
        super('text', displayName, defaultValue)
    }

    toBuilderDataItem(): Builder.DataItem {
        return {
            ...super.toBuilderDataItem(),
            [DATA.DATA_TYPE.text]: {
                maxLength: this.maxLength
            }
        }
    }
}
